import { Endpoint } from './interface/endpoint';
import { Verb } from './verb';

export class ControllerEndpoint implements Endpoint {
    constructor(public route: string, public verb: Verb) { }
}
